import React, { Fragment, useState } from "react";
import EAFlyByButton from "../../EAFlyByButton";
import DruckausgabeDialog from "./DruckausgabeDialog";

export default function DruckausgabeFlyByButton({ navTree, navTreeLoading }) {
    const [druckausgabeDlgOpen, setDruckausgabeDlgOpen] = useState(false);

    return (
        <Fragment>
            <DruckausgabeDialog
                navTreeLoading={navTreeLoading}
                open={druckausgabeDlgOpen}
                onClose={() => setDruckausgabeDlgOpen(false)}
                navTree={navTree}
            />
            <EAFlyByButton
                loading={navTreeLoading}
                iconName="ico-druck"
                id="druckausgabeButton"
                label="Druckausgabe"
                onClick={() => setDruckausgabeDlgOpen(true)}
            />
        </Fragment>
    );
}
